import { JDSDatepickerCalendarHeaderProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerCalendarHeaderProps>
  ): React.FC<JDSDatepickerCalendarHeaderProps> =>
  (props: JDSDatepickerCalendarHeaderProps) => {
    return <Component {...props} />;
  };
